/* ============================================================
   PDP Wellbeinn Band (secciones band-pdp-*). Vanilla JS, sin dependencias.
   - Color, stock y galería por variante
   - Correas extra (varias por color) y complementos con precio de pack (app Bundles)
   - Total en vivo, ahorro, barra fija y botones del ecosistema sincronizados
   - Añadir a la cesta: una sola llamada a cart/add.js; Comprar ahora: enlace de carrito
   - Chat de MATE: cambia solo al tocar un tema (nada ligado al scroll)
   Los precios llegan en céntimos y en la moneda del mercado actual (#band-pdp-config).
   ============================================================ */
(function () {
  'use strict';
  if (window.__bandPdp) return;
  window.__bandPdp = true;

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Formato de dinero de Shopify (shop.money_format) */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/, fmt = format || '€{{amount_with_comma_separator}}';
    function delim(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands), c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = fmt.match(placeholder), v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': v = delim(cents, 2); break;
      case 'amount_no_decimals': v = delim(cents, 0); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': v = delim(cents, 2, ' ', '.'); break;
      default: v = delim(cents, 2);
    }
    return fmt.replace(placeholder, v).replace(/<[^>]*>/g, '');
  }

  ready(function () {
    var cfgEl = document.getElementById('band-pdp-config');
    if (!cfgEl) return;
    var C = JSON.parse(cfgEl.textContent), T = C.i18n || {};
    var money = function (c) { return formatMoney(c, C.moneyFormat); };

    /* Capas fijas (barra inferior y hoja de detalle) colgando del body: el tema pone content-visibility:auto en las
       secciones a partir de la tercera y eso las convierte en el bloque contenedor de position:fixed. */
    (function () {
      var host = document.createElement('div');
      host.className = 'bp bp-layer';
      $$('[data-bp-sticky], [data-bp-sheet]').forEach(function (el) { host.appendChild(el); });
      if (host.children.length) document.body.appendChild(host);
    })();

    /* PayPal Pay Later (Shopify): su script pone el mensaje junto al primer importe que reconoce, que aquí era la
       tabla comparativa. Si aún no se ha pintado, lo llevamos bajo el precio; si ya tiene su iframe, se queda oculto
       por CSS dentro de la tabla. */
    (function () {
      var price = $('#buy .b-price'); if (!price) return;
      var tries = 0;
      var place = function () {
        var el = document.getElementById('paypal-upstream-messaging-product');
        if (!el || el.closest('#buy')) return !!el;
        if (!el.querySelector('iframe')) price.insertAdjacentElement('afterend', el);
        return true;
      };
      if (place()) return;
      var mo = new MutationObserver(function () { if (place() || ++tries > 400) mo.disconnect(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    })();

    /* seQura «Paga en 3 plazos sin intereses» bajo el precio (integración oficial: configuración + loader con cola onLoad).
       Donde se muestra, el mensaje de PayPal queda oculto desde la sección. */
    (function () {
      var sq = $('[data-bp-sequra]'); if (!sq) return;
      var refresh = function () { try { window.Sequra.refreshComponents(); } catch (e) {} };
      if (window.Sequra && typeof window.Sequra.refreshComponents === 'function') { refresh(); return; }
      if (window.SequraConfiguration && window.Sequra && window.Sequra.onLoad) { window.Sequra.onLoad(refresh); return; }
      var cfg = {
        merchant: sq.getAttribute('data-merchant'),
        assetKey: sq.getAttribute('data-assetkey'),
        products: [sq.getAttribute('data-product') || 'pp3'],
        scriptUri: 'https://live.sequracdn.com/assets/sequra-checkout.min.js',
        decimalSeparator: ',',
        thousandSeparator: '.',
        locale: sq.getAttribute('data-locale') || 'es',
        currency: sq.getAttribute('data-currency') || 'EUR'
      };
      window.SequraConfiguration = cfg;
      window.SequraOnLoad = window.SequraOnLoad || [];
      window.Sequra = window.Sequra || {};
      window.Sequra.onLoad = window.Sequra.onLoad || function (cb) { window.SequraOnLoad.push(cb); };
      window.Sequra.onLoad(refresh);
      var s = document.createElement('script'); s.async = true; s.src = cfg.scriptUri;
      document.head.appendChild(s);
    })();
    var moneyShort =function (c) { return money(c).replace(/[.,]00(?=\D*$)/, ''); };
    var root = document.getElementById('bp-main');

    var codes = Object.keys(C.band || {});
    var state = {
      color: (C.band[C.selected] && C.band[C.selected].available) ? C.selected : (codes.filter(function (k) { return C.band[k].available; })[0] || C.selected),
      addons: { balance: false, promax: false },
      straps: {}
    };
    Object.keys(C.strap || {}).forEach(function (k) { state.straps[k] = 0; });

    function band() { return C.band[state.color] || {}; }
    function pack(kind) { return ((C.packs || {})[kind] || {})[state.color]; }
    function strapCount() { var n = 0; for (var k in state.straps) n += state.straps[k]; return n; }
    function strapTotal() { var t = 0; for (var k in state.straps) if (state.straps[k] && C.strap[k]) t += state.straps[k] * C.strap[k].price; return t; }
    function packKind() { var b = state.addons.balance, p = state.addons.promax; return b && p ? 'all' : b ? 'balance' : p ? 'promax' : null; }
    function packOk(kind) { var p = pack(kind); return !!(p && p.available); }
    function mainTotal() { var k = packKind(); return k && packOk(k) ? pack(k).price : band().price; }
    function listTotal() { var t = band().price; if (state.addons.balance) t += C.list.balance; if (state.addons.promax) t += C.list.promax; return t; }
    function total() { return mainTotal() + strapTotal(); }
    function list() { return listTotal() + strapTotal(); }

    function names() {
      var a = [];
      if (state.addons.balance) a.push(T.nameBalance);
      if (state.addons.promax) a.push(T.namePromax);
      var s = strapCount();
      if (s) a.push(s + ' ' + (s > 1 ? T.strapMany : T.strapOne));
      return a;
    }

    /* ---------- Render ---------- */
    function render() {
      var b = band(), tot = total(), was = list(), save = was - tot, n = names(), extras = n.length;
      $$('[data-bp-total]').forEach(function (el) { el.textContent = money(tot); });
      var tw = $('[data-bp-total-was]'); if (tw) { tw.hidden = save <= 0; tw.textContent = money(was); }
      var sv = $('[data-bp-saved]'); if (sv) { sv.hidden = save <= 0; sv.textContent = (T.saved || '').replace('[amount]', money(save)); }
      var bp = $('[data-bp-band-price]'); if (bp) bp.textContent = money(b.price);
      $$('[data-bp-color-name]').forEach(function (el) { el.textContent = b.name || ''; });
      $$('[data-bp-color]').forEach(function (s) { s.setAttribute('aria-checked', s.getAttribute('data-bp-color') === state.color ? 'true' : 'false'); });

      /* stock */
      var st = $('[data-bp-stock]');
      if (st) {
        var low = b.available && b.qty > 0 && b.qty <= C.low;
        st.classList.toggle('on', !!low);
        $('span', st).textContent = low ? (T.lowMsg || '').replace('[color]', b.name) : '';
      }

      /* complementos */
      var ab = state.addons.balance, ap = state.addons.promax;
      $$('[data-bp-addon]').forEach(function (el) { el.setAttribute('aria-checked', state.addons[el.getAttribute('data-bp-addon')] ? 'true' : 'false'); });
      ['balance', 'promax'].forEach(function (k) {
        var p = pack(k), pr = $('[data-bp-addon-price="' + k + '"]');
        if (p && pr) pr.textContent = money(p.price - b.price);
      });
      var hint = $('[data-bp-pack-hint]'), done = $('[data-bp-pack-done]'), tpl = $('[data-bp-pack-hint-tpl]');
      if (hint && tpl) {
        hint.classList.toggle('on', (ab || ap) && !(ab && ap));
        $('[data-bp-pack-hint-text]').innerHTML = tpl.innerHTML.replace('[name]', ab ? T.namePromax : T.nameBalance);
      }
      if (done) done.classList.toggle('on', ab && ap);
      var sl = $('[data-bp-sum-label]'); if (sl) sl.textContent = extras ? 'Band + ' + n.join(' + ') : T.sumDefault;
      $$('[data-bp-final-lines]').forEach(function (el) { el.textContent = extras ? '+ ' + n.join(' + ') : T.noExtras; });
      $$('[data-bp-sticky-extra]').forEach(function (el) { el.textContent = extras ? (extras > 1 ? (T.extraMany || '').replace('[n]', extras) : T.extraOne) : ''; });
      $$('[data-bp-eco]').forEach(function (btn) {
        var on = state.addons[btn.getAttribute('data-bp-eco')];
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.innerHTML = '<svg width="12" height="12"><use href="#bp-i-' + (on ? 'tick' : 'plus') + '"/></svg>' + (on ? T.ecoAdded : T.ecoAdd);
      });

      /* correas */
      var sc = strapCount();
      $$('[data-bp-strap]').forEach(function (el) {
        var k = el.getAttribute('data-bp-strap'), q = state.straps[k] || 0, out = $('output', el), minus = $('[data-s="-1"]', el);
        if (out) out.textContent = q;
        el.classList.toggle('has', q > 0);
        if (minus) minus.disabled = q === 0;
      });
      var ssum = $('[data-bp-straps-sum]');
      if (ssum) {
        if (sc) {
          var parts = [];
          Object.keys(state.straps).forEach(function (k) { if (state.straps[k]) parts.push(state.straps[k] + '× ' + (C.band[k] ? C.band[k].name : k)); });
          ssum.textContent = parts.join(' · ') + ' · ' + money(strapTotal());
        } else {
          var anyStrap = C.strap[Object.keys(C.strap)[0]];
          ssum.textContent = (T.strapsSub || '').replace('[price]', anyStrap ? money(anyStrap.price) : '');
        }
      }
      var scta = $('[data-bp-straps-cta]'); if (scta) scta.textContent = sc ? T.strapsEdit : T.strapsAdd;

      /* botones */
      var dis = !b.available;
      $$('[data-bp-atc],[data-bp-buy]').forEach(function (btn) { btn.disabled = dis; });
      $$('[data-bp-atc-label]').forEach(function (el) { el.textContent = dis ? T.soldout : T.atc; });
    }

    /* ---------- Complementos ---------- */
    function toggle(k) { if (!C.addons) return; state.addons[k] = !state.addons[k]; render(); }
    $$('[data-bp-addon]').forEach(function (el) {
      el.addEventListener('click', function (e) { if (e.target.closest('[data-bp-detail]')) return; toggle(el.getAttribute('data-bp-addon')); });
      el.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(el.getAttribute('data-bp-addon')); } });
    });
    $$('[data-bp-eco]').forEach(function (b) { b.addEventListener('click', function () { toggle(b.getAttribute('data-bp-eco')); }); });

    /* Ahorro por complemento: el texto viene renderizado en Liquid con el importe del color inicial;
       si el color cambia, se recalcula (todos los colores suelen tener el mismo precio de pack). */
    function refreshSaves() {
      ['balance', 'promax'].forEach(function (k) {
        var el = $('[data-bp-addon-save="' + k + '"]'), p = pack(k);
        if (!el || !p) return;
        var amount = moneyShort(C.list[k] - (p.price - band().price));
        var tpl = el.getAttribute('data-save-tpl');
        if (tpl) el.textContent = tpl.replace('[amount]', amount);
      });
    }

    /* ---------- Correas ---------- */
    $$('[data-bp-strap]').forEach(function (el) {
      $$('[data-s]', el).forEach(function (b) {
        b.addEventListener('click', function () {
          var k = el.getAttribute('data-bp-strap');
          state.straps[k] = Math.max(0, Math.min(5, (state.straps[k] || 0) + parseInt(b.getAttribute('data-s'), 10)));
          render();
        });
      });
    });

    /* ---------- Color ---------- */
    function setImg(img, src) { if (img && src) { img.removeAttribute('srcset'); img.src = src; } }
    $$('[data-bp-color]').forEach(function (s) {
      s.addEventListener('click', function () {
        var k = s.getAttribute('data-bp-color');
        if (!C.band[k] || !C.band[k].available) return;
        state.color = k;
        var b = band();
        setImg($('[data-bp-variant-img]'), b.img); setImg($('[data-bp-variant-thumb]'), b.thumb);
        $$('[data-bp-variant-small]').forEach(function (i) { setImg(i, b.thumb); });
        var main = $('[data-bp-variant-img]'); if (main) main.alt = (T.sumDefault || '') + ' ' + b.name;
        var tr = $('[data-bp-gallery]'); if (tr) tr.scrollTo({ left: 0, behavior: 'smooth' });
        try { var u = new URL(location.href); u.searchParams.set('variant', b.id); history.replaceState(null, '', u.toString()); } catch (e) {}
        render(); refreshSaves();
      });
    });

    /* ---------- Galería ---------- */
    var track = $('[data-bp-gallery]');
    if (track) {
      var slides = $$('.b-gallery__slide', track), thumbs = $$('[data-bp-thumbs] button'), gd = $('[data-bp-gallery-dots]');
      var go = function (i) { var s = slides[i]; if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); };
      if (gd && slides.length > 1) slides.forEach(function (_, i) { var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', String(i + 1)); d.addEventListener('click', function () { go(i); }); gd.appendChild(d); });
      var syncG = function () {
        var w = slides[0].getBoundingClientRect().width + 8, i = Math.min(Math.round(track.scrollLeft / w), slides.length - 1);
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
        if (gd) $$('button', gd).forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      };
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(syncG); }, { passive: true });
      syncG();
    }

    /* ---------- Vídeo: se reproduce solo a la vista, sin sonido y en bucle ---------- */
    var vids = $$('[data-bp-vid]');
    if (vids.length) {
      var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var playV = function (v) { if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      var setSound = function (w, on) {
        var v = $('video', w), b = $('[data-bp-vid-sound]', w);
        if (!v) return;
        v.muted = !on;
        if (on) playV(v);
        if (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', b.getAttribute(on ? 'data-label-off' : 'data-label-on') || ''); }
      };
      var toggleSound = function (w) {
        var v = $('video', w); if (!v) return;
        var on = v.muted;
        if (on) vids.forEach(function (o) { if (o !== w) setSound(o, false); });
        setSound(w, on);
      };
      vids.forEach(function (w) {
        var v = $('video', w); if (!v) return;
        v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', '');
        if (reduceMotion) v.controls = true;
        else v.addEventListener('click', function () { toggleSound(w); });
        var b = $('[data-bp-vid-sound]', w);
        if (b) b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggleSound(w); });
      });
      if (!reduceMotion && 'IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var v = $('video', e.target); if (!v) return;
            if (e.isIntersecting && e.intersectionRatio >= 0.5) playV(v);
            else if (!v.paused) v.pause();
          });
        }, { threshold: [0, 0.5, 1] });
        vids.forEach(function (w) { vio.observe(w); });
      }
    }

    /* ---------- Carruseles con puntos ---------- */
    $$('[data-bp-dots-for]').forEach(function (dw) {
      var c = $('[data-bp-carousel="' + dw.getAttribute('data-bp-dots-for') + '"]');
      if (!c) return;
      var items = Array.prototype.slice.call(c.children);
      items.forEach(function (it, i) { var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', String(i + 1)); d.addEventListener('click', function () { c.scrollTo({ left: it.offsetLeft - c.offsetLeft - 16, behavior: 'smooth' }); }); dw.appendChild(d); });
      var sync = function () { var w = items[0].getBoundingClientRect().width + 12, i = Math.min(Math.round(c.scrollLeft / w), items.length - 1); $$('button', dw).forEach(function (d, j) { d.classList.toggle('is-active', j === i); }); };
      c.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true }); sync();
    });

    /* ---------- Hoja de detalle ---------- */
    var sheet = $('[data-bp-sheet="detail"]'), current = null, lastFocus = null;
    function openSheet() { if (!sheet) return; lastFocus = document.activeElement; sheet.classList.add('is-open'); sheet.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; var c = $('.b-sheet__close', sheet); if (c) c.focus(); }
    function closeSheet() { if (!sheet) return; sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    function renderDetail() {
      var on = state.addons[current], btn = $('[data-bp-d-toggle]', sheet);
      $('[data-bp-d-price-label]', sheet).textContent = on ? T.detailPriceIn : T.detailPriceAdd;
      btn.textContent = on ? T.detailRemove : T.detailAdd;
      btn.classList.toggle('is-ghost', !!on);
    }
    if (sheet) {
      $$('[data-bp-close]', sheet).forEach(function (b) { b.addEventListener('click', closeSheet); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); });
      $('[data-bp-d-toggle]', sheet).addEventListener('click', function () { toggle(current); renderDetail(); setTimeout(closeSheet, 250); });
    }
    $$('[data-bp-detail]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var k = b.getAttribute('data-bp-detail'), d = (C.detail || {})[k], p = pack(k);
        if (!d || !sheet) return;
        current = k;
        $('[data-bp-d-title]', sheet).textContent = d.title;
        $('[data-bp-d-text]', sheet).textContent = d.text || '';
        var img = $('[data-bp-d-img]', sheet); if (d.img) { img.src = d.img; img.alt = d.title; }
        var ul = $('[data-bp-d-list]', sheet); ul.innerHTML = '';
        (d.list || []).filter(function (t) { return t && t.trim(); }).forEach(function (t) {
          var li = document.createElement('li');
          li.innerHTML = '<svg class="ico" width="16" height="16"><use href="#bp-i-check"/></svg>';
          var sp = document.createElement('span'); sp.textContent = t.trim(); li.appendChild(sp); ul.appendChild(li);
        });
        var pr = $('[data-bp-d-price]', sheet);
        pr.innerHTML = '';
        if (p) {
          pr.appendChild(document.createTextNode('+' + money(p.price - band().price) + ' '));
          var s = document.createElement('s'); s.textContent = money(C.list[k]); pr.appendChild(s);
        }
        renderDetail(); openSheet();
      });
    });

    /* ---------- Compra ---------- */
    function items() {
      var b = band();
      if (!b.available) return null;
      var k = packKind(), out = [];
      if (k && packOk(k)) out.push({ id: pack(k).id, quantity: 1 });
      else out.push({ id: b.id, quantity: 1 });
      Object.keys(state.straps).forEach(function (c) { var q = state.straps[c]; if (q && C.strap[c] && C.strap[c].available) out.push({ id: C.strap[c].id, quantity: q }); });
      return out;
    }
    function showError() { var e = $('[data-bp-error]'); if (e) { e.textContent = T.error; e.hidden = false; setTimeout(function () { e.hidden = true; }, 5000); } }
    function openCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var t = document.querySelector('[data-cart-drawer-toggle], a[href$="/cart"][data-drawer]');
      if (t) t.click(); else location.href = C.cart;
    }
    $$('[data-bp-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = items();
        if (!list) return;
        var label = $('[data-bp-atc-label]', btn), prev = label ? label.textContent : '';
        btn.disabled = true; if (label) label.textContent = T.adding;
        fetch(C.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) })
          .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
          .then(function () { openCart(); })
          .catch(function () { showError(); })
          .finally(function () { btn.disabled = false; if (label) label.textContent = prev; render(); });
      });
    });
    $$('[data-bp-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = items();
        if (!list) return;
        location.href = C.cart.replace(/\/$/, '') + '/' + list.map(function (i) { return i.id + ':' + i.quantity; }).join(',');
      });
    });

    /* ---------- Barra fija (visibilidad del botón principal, no efecto de scroll) ---------- */
    var sticky = $('[data-bp-sticky]'), mainAtc = $('#buy [data-bp-atc]'), finalCard = $('.b-final');
    if (sticky && mainAtc) {
      var inView = function (el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight); };
      var upd = function () { var on = mainAtc.getBoundingClientRect().bottom <= 0 && !inView(finalCard); sticky.classList.toggle('is-visible', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(upd);
        io.observe(mainAtc); if (finalCard) io.observe(finalCard);
      }
      /* Respaldo: saltos de scroll (anclas, restauración, scroll rápido) que el observer puede no notificar */
      var ticking = false;
      var onScroll = function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; upd(); }); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      upd();
    }

    /* ---------- MATE: conversación por tema ---------- */
    var mateCfg = document.getElementById('band-pdp-mate');
    if (mateCfg) {
      var M = JSON.parse(mateCfg.textContent), chat = $('[data-bp-chat]'), sugs = $('[data-bp-sugs]'), run = 0;
      var pills = $$('[data-bp-topic]');
      var bubble = function (html, cls) { var d = document.createElement('div'); d.className = 'co-msg ' + cls; d.innerHTML = html; chat.appendChild(d); };
      var card = function (t) { var d = document.createElement('div'); d.className = 'co-card'; d.innerHTML = '<span class="wt"></span><span class="wv"><span></span><small></small></span><div class="bar"><i></i></div>'; $('.wt', d).textContent = t.label; $('.wv', d).style.color = t.color; $('.wv > span', d).textContent = t.value; $('.wv small', d).textContent = t.unit || ''; var i = $('.bar i', d); i.style.width = (t.pct || 0) + '%'; i.style.background = t.color; chat.appendChild(d); };
      var talk = function (idx, animate) {
        var t = M.topics[idx]; if (!t || !chat) return;
        var me = ++run; chat.innerHTML = '';
        pills.forEach(function (p) { var on = parseInt(p.getAttribute('data-bp-topic'), 10) === idx; p.classList.toggle('on', on); p.setAttribute('aria-selected', on ? 'true' : 'false'); });
        var q = document.createElement('div'); q.className = 'co-msg me'; q.textContent = t.q; chat.appendChild(q);
        if (sugs) { sugs.innerHTML = ''; M.topics.forEach(function (o, j) { if (j === idx) return; var b = document.createElement('button'); b.type = 'button'; b.textContent = o.q; b.addEventListener('click', function () { talk(j, true); }); sugs.appendChild(b); }); }
        var parts = [{ html: t.a1 }]; if (t.label) parts.push({ card: t }); if (t.a2) parts.push({ html: t.a2 });
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!animate || reduce) { parts.forEach(function (p) { p.card ? card(p.card) : bubble(p.html, 'bot'); }); return; }
        var i = 0;
        (function next() {
          if (me !== run || i >= parts.length) return;
          var ty = document.createElement('div'); ty.className = 'co-typing'; ty.innerHTML = '<i></i><i></i><i></i>'; chat.appendChild(ty);
          setTimeout(function () { if (me !== run) return; ty.remove(); var p = parts[i++]; p.card ? card(p.card) : bubble(p.html, 'bot'); setTimeout(next, 250); }, 650);
        })();
      };
      pills.forEach(function (p) { p.addEventListener('click', function () { talk(parseInt(p.getAttribute('data-bp-topic'), 10), true); }); });
      talk(0, false);
    }

    render();
    refreshSaves();
  });
})();
